<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="acknowledgment">
<p class="ct"><a class="xref" href="#/OEBPS/ppprecoil007#toc">Acknowledgments</a></p>
<p class="pf">I am grateful to several people for providing technical information that I used in this novel. I would like to thank in particular Fidel Duenas, Rick Jones, and Paul Pierce.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-recoil005.vue?4114ca78